import React, { type PropsWithChildren } from "react";

import clsx from "clsx";

type SelectableChoiceProps<T> = {
  selectedValue: T;
  value: T;
  onClick: (val: T) => void;
};

export function SelectableChoice<T>({
  children,
  selectedValue,
  value,
  onClick,
}: PropsWithChildren<SelectableChoiceProps<T>>) {
  const isSelected = selectedValue === value;
  return (
    <div
      className={clsx(
        "w-full p-2 text-xs hover:bg-v2-secondary cursor-pointer",
        {
          "bg-cosmic-3 font-semibold": isSelected,
        },
      )}
      onClick={() => onClick(value)}
    >
      {children}
    </div>
  );
}
